///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { dateFormat, division } from "./types";

const normalizeUtc = startDateUTC =>
  startDateUTC && !startDateUTC.endsWith("Z") ? `${startDateUTC}Z` : startDateUTC;

const getStartDate = (bid, user, timeZone, expectedFormat) => {
  if (!bid.startDateUTC) {
    return "";
  }

  const zonedStartDate = utcToZonedTime(normalizeUtc(bid.startDateUTC), timeZone);
  const startDateFormat =
    expectedFormat ||
    (user.division === division.coy
      ? dateFormat.MMddyyyy
      : dateFormat.ddMMyyyy);
  const formattedStartDate = format(zonedStartDate, startDateFormat);

  return formattedStartDate;
};

export default getStartDate;
